export const BUILD_MODE = import.meta.env.MODE;
export const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN;
export const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID;
export const AUTH0_API_AUDIENCE = import.meta.env.VITE_AUTH0_API_AUDIENCE;
export const AUTH0_CALL_BACK_URL = import.meta.env.VITE_AUTH0_CALL_BACK_URL;
export const CUSTOMER_SERVICE_URL = import.meta.env.VITE_CUSTOMER_SERVICE_URL;
export const ENABLE_TRIGGER_IMMEDIATELY_OPTION = true;
